"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
const utils_1 = require("@loadsure/utils");
class Commodity {
    constructor(id, name, category, newUsedApplicable, tempSensitive, hsCodes, usaExclusions, worldwideExclusions, sortOrder) {
        this.id = id;
        this.name = name;
        this.category = category;
        this.newUsedApplicable = newUsedApplicable;
        this.tempSensitive = tempSensitive;
        this.hsCodes = hsCodes;
        this.usaExclusions = usaExclusions;
        this.worldwideExclusions = worldwideExclusions;
        this.sortOrder = sortOrder;
    }
    get item() {
        return {
            id: this.id,
            name: this.name
        };
    }
}
exports.default = Commodity;
Commodity.fromObj = (data) => new Commodity(data.id, data.name, utils_1.getEnumKey("category", index_1.eCommodityCategory, data.category), data.newUsedApplicable, data.tempSensitive, data.hsCodes, data.usaExclusions, data.worldwideExclusions, data.sortOrder);
//# sourceMappingURL=commodity.class.js.map